import { utcDateString } from "../puzzle/generator.ts";
import type { Puzzle } from "../puzzle/types.ts";
import { normalizeDisplayName } from "../shared/competition.ts";
import { APP_CONFIG } from "./config.ts";
import { attemptLimit, formatElapsed, type PuzzleProgress } from "./storage.ts";

export interface ResultSummary {
  date: string;
  puzzleNumber: number;
  solved: boolean;
  attempts: number;
  maxAttempts: number;
  elapsedMs: number;
  name?: string;
}

export function resultSummary(puzzle: Puzzle, progress: PuzzleProgress, rememberedName = ""): ResultSummary {
  if (progress.date !== puzzle.date) throw new Error("The result belongs to a different puzzle.");
  if (progress.status !== "solved" && progress.status !== "failed") {
    throw new Error("Finish the puzzle before sharing a result.");
  }
  const elapsedMs = progress.solveTimeMs;
  if (elapsedMs === undefined || !Number.isFinite(elapsedMs) || elapsedMs < 0) {
    throw new Error("This result has no recorded time.");
  }
  const name = normalizeDisplayName(progress.leaderboardName) ?? normalizeDisplayName(rememberedName);
  return {
    date: utcDateString(puzzle.date),
    puzzleNumber: puzzle.puzzleNumber,
    solved: progress.status === "solved",
    attempts: progress.attempts.length,
    maxAttempts: attemptLimit(progress),
    elapsedMs,
    ...(name ? { name } : {}),
  };
}

export function resultDescription(summary: ResultSummary): string {
  const outcome = summary.solved ? "Solved" : "Not solved";
  const player = summary.name ? `Player ${summary.name}. ` : "";
  return `${APP_CONFIG.name} #${summary.puzzleNumber}, ${summary.date}. ${player}${outcome}. ${summary.attempts} of ${summary.maxAttempts} guesses. Time ${formatElapsed(summary.elapsedMs)}.`;
}

export function resultFilename(summary: ResultSummary): string {
  return `codelet-${summary.date}.png`;
}